@if (type==0) {
  <div  [style.background-color]="item.customField15" style="border-radius: 12px;">
    <div class="input-row backg" [formGroup]="firstFormGroup" autocomplete="off">
      <div fxLayout="column">
        <div class="result padding-10" fxLayout="column">
          <!-- Dynamic Input Row with Field Wrapping -->
          @if (item.type!='mapsWithContactForm' ) {
            <h1>{{item.title}}</h1>
          }
          <div class="input-row" fxLayout="row wrap" fxLayoutGap="10px grid">
            <!-- Fields will wrap dynamically based on the number of fields specified in customField26 -->
            @for (field of getFormFields(item.customField26, fieldData); track field) {
              <mat-form-field
                [fxFlex]="getFlexValue(item.customField26)"  [fxFlex.xs]="getMobileFlexValue(item.customField27)"
                appearance="outline">
                <mat-label>{{field.label}}</mat-label>
                @if (field.type === 'text') {
                  <input [autocomplete]="'off'" trim="blur" matInput [formControlName]="field.controlName" required>
                }
                @if (field.type === 'textarea') {
                  <textarea trim="blur" matInput [formControlName]="field.controlName" required></textarea>
                }
                @if (firstFormGroup.controls[field.controlName].errors?.required) {
                  <mat-error>
                    Please fill out this field.
                  </mat-error>
                }
              </mat-form-field>
            }
          </div>
        </div>
      </div>
    </div>
    <!-- Submit Button in Full Width and Last Row -->
    <div class="input-row1 padding-b10" fxLayout="row" style="width: 100%;">
      <button class="primary" style="color:white; width: 100%;margin:0px 15px" mat-flat-button [disabled]="text != 'Submit'" (click)="createContact()">
        {{text}}
        @if (text != 'Submit') {
          <mat-icon>
            <mat-spinner class="primary" diameter="20"></mat-spinner>
          </mat-icon>
        }
      </button>
    </div>
  </div>
}



@if (type==1) {
  <div class="padding-10" [style.background-color]="item.customField15" style="border-radius: 12px;" [id]="item.customField35">
    <div class="input-row backg" autocomplete="off">
      <div fxLayout="column">
        <div class="result" [ngClass]="noPadding ? '' : 'padding-10'" fxLayout="column">
          <div class="input-row1 padding-b10" fxLayout="row"
            [fxLayoutAlign]="item.customField12" fxflex="100"   >
            <div style="width: 100%" >
              <calsoft-editor-text [data]="data" [text]="input" [align]="item.customField34"           [style.font-size]="item.customField39" [ngStyle.lt-md]="{ 'font-size': item.customField40 }">
              </calsoft-editor-text>
            </div>
          </div>
          @if (init) {
            <div>
              <dynamic-form  [layout]="alignMent" [SuccessMessage]="customField28" [FailerMessage]="customField29" [redirectUrl]="customField10" [customField13]="customField13" [customField5]="customField5" 
              [fields]="regConfig" [newFormField]="customField8" (formSubmit)="submit($event)"  [customField32]="customField32"      [customField33]="customField33"   [privacydescripition]="customField25"   [broucherfile]="customField24"
>
              </dynamic-form>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
}
